import { Navbar } from '@/components/layout/Navbar';
import { useTranslation } from 'react-i18next';
import { Footer } from '@/components/layout/Footer';

export default function Terms() {
  const { t } = useTranslation();

  // Key stems only — the clause copy lives in locales/{en,es}.json.
  const sections = ['using', 'accounts', 'payments', 'content', 'acceptable', 'protection', 'changes', 'liability'];



  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <section className="py-16">
          <div className="container mx-auto px-4 max-w-3xl">
            <h1 className="text-3xl md:text-4xl font-bold mb-6">{t('legal.termsOfService')}</h1>
            <p className="text-muted-foreground mb-8">
              {t('legal.termsIntro')}
            </p>
            <div className="space-y-8">
              {sections.map((section) => (
                <section key={section} className="space-y-3">
                  <h2 className="text-xl font-semibold">{t(`legal.termsSections.${section}Title`)}</h2>
                  <p className="leading-7 text-muted-foreground">{t(`legal.termsSections.${section}Body`)}</p>
                </section>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

